import { FC, ReactNode } from 'react';
import { clsx, UsersAutocompleteOption } from '@sweatpals/react-ui-kit';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FileVariantsEnum } from '@sweatpals/shared';
import { getPublicFileUrl } from '../../../utils/file.utils';
import { SponsorCard } from './sponsor-card.component';
import { sponsorListRootStyles, sponsorListStyles, sponsorListTitleStyles } from './sponsor-list.styles';

export interface SponsorListProps {
	title: ReactNode;
	users: (UsersAutocompleteOption & { url?: string })[];
	sx?: SxProps<Theme>;
	cardSx?: SxProps<Theme>;
	cardAvatarSx?: SxProps<Theme>;
}

export const SponsorList: FC<SponsorListProps> = props => {
	const { title, users, sx, cardSx, cardAvatarSx } = props;

	return (
		<Box sx={clsx(sponsorListRootStyles, sx)}>
			<Typography sx={sponsorListTitleStyles}>{title}</Typography>

			<Box sx={sponsorListStyles}>
				{users.map(user => (
					<SponsorCard
						key={user.id}
						sx={cardSx}
						avatarSx={cardAvatarSx}
						url={user.url}
						user={{
							...user,
							avatarSrc: user.avatarId
								? getPublicFileUrl(user.avatarId, {
										variant: FileVariantsEnum.M,
								  })
								: undefined,
						}}
					/>
				))}
			</Box>
		</Box>
	);
};
